var _circle, _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryMeestExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 15,
    cy: 15.0002,
    r: 12.6316,
    fill: "#169CE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.161 10.3369V16.5264H13.0115V13.8737H9.81067V16.5264H8.66119V10.3369H9.81067V12.8923H13.0115V10.3369H14.161ZM21.3793 10.3369V16.5264H20.2475V11.3095H17.0378V16.5264H15.9061V10.3369H21.3793Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.61865,
    y: 2.61816,
    width: 24.7632,
    height: 24.7632,
    rx: 3.53947,
    fill: "white",
    stroke: "#DBE4F0",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6109_3323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4433 15.0383C13.4433 14.03 12.0751 14.0161 12.0819 15.0383H13.4433ZM12.0751 15.8181C12.1481 16.711 13.5493 16.5553 14.1559 16.365L14.3053 17.1379C12.8869 17.6766 10.9988 17.3248 10.9988 15.4951C10.9988 13.0552 14.5139 12.791 14.5139 15.3682C14.5139 15.519 14.5013 15.6695 14.4763 15.8181H12.0751Z",
    fill: "#E60033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6856 12.6328H22.908L23.6867 14.0299L22.908 15.4269H23.6856L24.4734 14.0299L23.6856 12.6328Z",
    fill: "#E60033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3996 14.6356C19.3996 14.1742 20.2707 14.3219 20.5341 14.4268L20.6162 13.6551C19.7326 13.3839 18.3644 13.5858 18.3667 14.7383C18.3484 15.8747 20.0347 15.7189 20.0347 16.26C20.0347 16.831 18.7133 16.5392 18.4259 16.365L18.2754 17.1379C19.2583 17.5682 21.1259 17.4736 21.0723 16.1804C21.0552 14.9275 19.3996 15.149 19.3996 14.6356ZM17.1558 15.0383C17.1558 14.03 15.7876 14.0161 15.7944 15.0383H17.1558ZM15.7876 15.8181C15.8594 16.711 17.2618 16.5553 17.8684 16.365L18.0189 17.1379C16.6005 17.6766 14.7124 17.3248 14.7124 15.4951C14.7124 13.0552 18.2276 12.791 18.2276 15.3682C18.2275 15.519 18.2149 15.6695 18.1899 15.8181H15.7876Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7166 14.4264H21.2604V15.9607C21.2604 16.7683 21.4645 17.3682 22.363 17.3682C22.6176 17.3673 22.87 17.3192 23.1075 17.2263V16.3645C22.5705 16.4649 22.3094 16.4983 22.3094 15.7877V12.6313H21.2604V13.6535H20.8043L20.7166 14.4264Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74369 17.292L9.65924 13.6546L9.90438 17.3682H10.9317L10.6181 12.6313H9.01505L8.22833 15.8154L7.44275 12.6313H5.83967L5.52612 17.3682H6.55342L6.79855 13.6546L7.71411 17.292H8.74369Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3287 14.0299L23.1201 13.6538H22.4941V14.4267H23.1076L23.3287 14.0299Z",
    fill: "#0061AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6109_3323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9474,
    height: 4.73684,
    fill: "white",
    transform: "translate(5.52612 12.6313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMeestExpress);
export default __webpack_public_path__ + "static/media/delivery_meest_express.f1b7ef3f70c20eacf2e6cc4b598190ff.svg";
export { ForwardRef as ReactComponent };